export const toClickedTimestamp = (rechartsState) => {
  const label = rechartsState?.activeLabel;
  const timestamp = Number(label);

  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
};
